<template>
  <!-- 头部整体盒子 -->
  <!--  -->
  <div id="header" class="container-fuild"  >
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container-fuild d-none d-xl-block" @mouseenter="OnMouse(7, '')">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/hhdimg/logo.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
      <!-- -->
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="index!=1?navClick(index, item.name):''"
          @mouseenter.stop="OnMouse(index, item.name)"
        >
        <!-- <el-popover v-if="item.path=='tab'" width="100%" placement="bottom" trigger="hover" >
         <productList /> -->
        <span v-if="item.path=='tab'" class="title_box">
            {{ item.name }}
            <span
             v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </span>
        <!-- </el-popover> -->
         
          <a v-else-if="item.url" :href="item.url">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </a>
          <router-link :to="item.path" v-else>
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
        </li>
        <li class="search-nav-item" >
          <div class="search_text" @click="isshowSearch = !isshowSearch">
            <img src="@/assets/hhdimg/1.png" />
            <span>{{$t('home.search')}}</span>
          </div>
          <div class="search-item" v-show="isshowSearch">
            <input v-model="searchValue" :placeholder="$t('home.search')"  @keyup.enter="onSearch"></input>
            <button class="search-btn" @click="onSearch">{{$t('home.search')}}</button>
          </div>
        </li>
        <!-- <li v-if="lang" class="nav-item" @click="gotoweb(0)">
          <img src="@/assets/hhdimg/2.png" />
          <span>{{$t('home.zhongwen')}}</span>
        </li>
        <li v-else class="nav-item" @click="gotoweb(1)">
          <img src="@/assets/hhdimg/2.png" />
          <span>{{$t('home.yingwen')}}</span>
          
        </li> -->
        <li class="nav-item">
           <el-dropdown @command="handleCommand">
             <div class="item_box">
             <img src="@/assets/hhdimg/2.png" />
             <span class="lang" v-if="lang==0">{{$t('home.zhongwen')}}</span>
             <span  class="lang" v-else>{{$t('home.yingwen')}}</span>
            </div>
           <el-dropdown-menu slot="dropdown">
           <el-dropdown-item :command="0">{{$t('home.zhongwen')}}</el-dropdown-item>
           <el-dropdown-item :command="1">{{$t('home.yingwen')}}</el-dropdown-item>
           </el-dropdown-menu>
          </el-dropdown>
    </li>

        <li class="nav-item" @click="gotoweb(2)">
          <img src="@/assets/hhdimg/3.png" />
          <span>{{$t('home.denglu')}}</span>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild d-xl-none">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu">
        <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/hhdimg/logo.png" alt="logo" />
        </div>
        <div class="header-nav-m-menu-wrapper">
          <div class="nav-item1" @click="isshowSearch = !isshowSearch">
            <img src="../assets/hhdimg/1.png" />
          </div>
          <div class="search-item1" v-show="isshowSearch">
            <input v-model="searchValue" :placeholder="$t('home.search')"  @keyup.enter="onSearch"></input>
            <button class="search-btn" @click="onSearch">{{$t('home.search')}}</button>
          </div>
          <div class="nav-item1">
            <el-dropdown @command="handleCommand">
             <div class="item_box">
              <img src="../assets/hhdimg/2.png" />
            </div>
           <el-dropdown-menu slot="dropdown">
           <el-dropdown-item :command="0">{{$t('home.zhongwen')}}</el-dropdown-item>
           <el-dropdown-item :command="1">{{$t('home.yingwen')}}</el-dropdown-item>
           </el-dropdown-menu>
          </el-dropdown>
            
          </div>
          <div class="nav-item1" @click="gotoweb(2)">
            <img src="../assets/hhdimg/3.png" />
          </div>
          <div @click="drawer = !drawer">
            <img src="../assets/hhdimg/nav/4.png" />
          </div>
        </div>
        <ul id="menu" v-show="drawer" class="header-nav-m-wrapper">
        <!--   -->
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-target="#menu"
          >
          <span v-if="item.path=='tab'" class="title_box">
            {{ item.name }}
            <span
             v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </span>
            <a  v-else-if="item.url" :href="item.url">
              {{ item.name }}
              <i class="underline"></i>
            </a>
            <router-link :to="item.path" v-else>
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <productList v-if="isProduct" @handleMouseLeave="handleMouseLeave" @hideProduct="hideProduct"/>
  </div>
</template>
<script>
import productList from './productList.vue'
export default {
  name: "Header",
  components:{
    productList
  },
  data() {
    return {
      drawer: false,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: this.$t("home.home"),
      lang:  this.$store.getters.lang==1,    //? true : false,
      isshowSearch: false,
      searchValue: "",
      isProduct:false,
      oldIndex:sessionStorage.getItem("navIndex")?sessionStorage.getItem("navIndex") : 0,
      oldName:this.$t("home.home"),
      navList: [
        {
          name: this.$t("home.home"),
          path: "/",
          children: [],
        },
        {
          name: this.$t("home.product"),
          // path: "/products",
          path:"tab",
          children: [],
        },
        {
          name: this.$t("home.sulotion"),
          path: "/service",
          children: [],
        },
        {
          name: this.$t("home.case"),
          path: "/case",
          children: [],
        },
        {
          name: this.$t("home.us"),
          path: "/companyintroduction",
          children: [],
        },
        {
          name: this.$t("home.news"),
          path: "/newsinformation",
          children: [],
        },
        {
          name: this.$t("home.bo"),
          url: this.$store.getters.lang==1 ? "http://www.hhdlink.com:8080/leek_bbs/index/":"http://www.hhdlink.cn:8080/leek_bbs/index/",
          children: [],
        },
        {
          name: this.$t("media.tip45"),
          path: "/websitePortal",
          children: [],
        },
      ],
    };
  },
  watch: {
    $route(to) {
      this.navIndex = to.meta.tab;
      console.log("349348=====ksklfls", this.navIndex);
      sessionStorage.setItem("navIndex", to.meta.tab);
    },
  },
  methods: {
   

    // 切换中英文
    handleCommand(data){
      console.log('2378=eeeee',data)
      this.$store.commit('setLang',data)
      // setTimeout(() => {
        location.reload()
      // }, 1000);
    },
    

    hideProduct(){
      this.isProduct=false
    },

    navClick(index, name) {
      this.drawer = false;
      if(index==1){
        this.isProduct=true
      }else{
        this.isProduct=false
      }
      if (name == "Blogs") {
      } else {
        this.oldIndex=this.navIndex
        this.oldName=this.menuName
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
        this.menuName = name;
      }
    },

    // 鼠标经过
    OnMouse(index, name){
      console.log('34873874============index',index)
      this.drawer = false;
      if(index==1){
        this.isProduct=true
      }else{
        this.isProduct=false
        this.navIndex = this.oldIndex;
        this.menuName=this.oldName
      }
      if(index!=7&&index==1){
      this.oldIndex=this.navIndex
      this.oldName=this.menuName
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
      }
    },

    // 
    handleMouseLeave(){
      console.log('324838=======sdsdskkkkkk',this.oldIndex,this.oldName)
      this.isProduct=false
      this.navIndex = this.oldIndex;
      this.menuName=this.oldName
      sessionStorage.setItem("navIndex", index);
    },
    gotoweb(index) {
      switch (index) {
        case 0:
          this.lang = true;
          
          window.location.reload();
          window.location = "https://www.hhdlink.cn/home/";
          break;
        case 1:
          this.lang = false;
          
          window.location.reload();
          window.location = "https://www.hhdlink.com/home/"; 
          
          break;
        case 2:
          // window.location = "https://hhdlink.online/";
          // window.location = "https://www.hhdlink.top";  //英文
          // window.location = "https://gpslock.hhdlink.online/";  //中文
          if(this.$store.getters.lang==1){
            window.location = "https://www.hhdlink.top"
          }else{
            window.location = "https://gpslock.hhdlink.online/"
          }
          break;
        default:
          break;
      }
      console.log("8988===78788", this.lang);
    },
    menuClick() {},

    // 搜索
    onSearch() {
      this.isshowSearch = false;
      this.$router.push({
        path: "searchResult",
        query: {
          data: encodeURIComponent(JSON.stringify(this.searchValue)),
        },
      });
      this.navIndex = -1;
      this.searchValue = "";
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
  
}

.search_text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
  padding:0 100px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  /* width: 180px; */
  height: 48px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  object-fit: contain;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 900;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 20px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  /* font-weight: bold; */
  padding: 20px 0;
  position: relative;
}


/deep/ .el-popover__reference-wrapper{
  .title_box{
    color: #000;
  font-size: 18px;
  /* font-weight: bold; */
  padding: 20px 0;
  position: relative;
  cursor:pointer;
  }

  .title_box > i {
  display: block;
  position: absolute;
  bottom: -4px;
  left: 50%;
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

.title_box:hover {
  color: #1e73be;
  text-decoration: none;
}

.title_box>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

.title_box:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

.title_box:hover span {
  transform: rotate(180deg);
}

/* .title_box {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 4px solid #1e73be;
} */

/* .title_box {
    width: 100%;
    color: #1e73be;
    font-size: 15px;
    font-weight: bold;
    padding: 18px 0;
    position: relative;
    text-align: center;
  } */

  span {
    font-size: 10px;
  }

}



#header .header-nav .header-nav-wrapper > li > .title_box {
  color: #000;
  font-size: 18px;
  padding: 20px 0;
  position: relative;
  cursor:pointer;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -4px;
  left: 50%;
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

#header .header-nav .header-nav-wrapper > li > .title_box > i {
  display: block;
  position: absolute;
  bottom: -4px;
  left: 50%;
  width: 0;
  height: 4px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* #header .header-nav .header-nav-wrapper > li > .title_box:hover {
  color: #1e73be;
  text-decoration: none;
} */

#header .header-nav .header-nav-wrapper > li > .title_box>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

#header .header-nav .header-nav-wrapper > li > .title_box:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

#header .header-nav .header-nav-wrapper > li > .title_box:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 4px solid #1e73be;
}


#header .header-nav .header-nav-wrapper > li.active> .title_box {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 4px solid #1e73be;
}


/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 1200px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 50%;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: auto;
    height: 100%;
    padding: 0 10px;
    /* position: absolute; */
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #fff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #header .header-nav-m .header-nav-m-menu-wrapper img {
    /* width: 25px; */
    height: 22px;
    margin-right: 20px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
  }
  #header .header-nav-m .header-nav-m-wrapper ul {
    margin: 0;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    width: 100%;
    color: #1e73be;
    font-size: 15px;
    font-weight: bold;
    padding: 18px 0;
    position: relative;
    text-align: center;
  }

  #header .header-nav-m .header-nav-m-wrapper > li> .title_box {
    width: 100%;
    color: #1e73be;
    font-size: 15px;
    font-weight: bold;
    padding: 18px 0;
    position: relative;
    text-align: center;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
  #header .header-nav .header-nav-wrapper > li > .title_box > span {
    font-size: 10px;
  }
}

.search-nav-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 111px;
  border-left: 1px solid #ddd;
  margin: 0 !important;
  padding: 0 20px;
  position: relative;
}

.search-item {
  position: absolute;
  bottom: -120px;
  width: 350px;
  height: 120px;
  background-color: #fff;
  z-index: 9999;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-item1{
  position: absolute;
  left:50%;
  bottom: -120px;
  width: 350px;
  height: 120px;
  background-color: #fff;
  z-index: 9999;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform:translateX(-50%);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
}

.search-btn {
  height: 50px;
  padding: 0 20px;
  background-color: #1e73be;
  border: 1px solid #1e73be;
  color: #fff;
  margin-left: 5px;
}

.search-item input {
  height: 50px;
  color: #666;
  padding: 0.7em;
  border-width: 1px;
  border-style: solid;
  border-color: #eaeaea;
  border-radius: 2px;
  background: #fafafa;
  box-shadow: none;
  box-sizing: border-box;
  transition: all 0.2s linear;
  font-size: 15px;
}

/* 修改input获取焦点后的样式 */
.search-item input:focus {
  box-shadow: 0px 0px 5px 0px rgba(64, 159, 255, 0.25);
  /* border:none; */
  outline: 1px solid #409eff;
}

/* 修改input获取焦点后占位符消失 */
.search-item input:focus::-webkit-input-placeholder {
  color: transparent;
}

.nav-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 111px;
  border-left: 1px solid #ddd;
  margin: 0 !important;
  padding: 0 20px;
}

.nav-item1{
  width:50px;
  display: flex;
  justify-content: center;
}

.nav-item:last-child {
  border-right: 1px solid #ddd;
}

.search-nav-item,
.nav-item span {
  line-height: 50px !important;
}

.item_box{
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}

.lang{
  display:flex;
  justify-content:center;
  align-items:center;
  line-height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue